import { render } from "./NewsRoomDetails.vue?vue&type=template&id=e0268adc&ts=true"
import script from "./NewsRoomDetails.vue?vue&type=script&lang=ts"
export * from "./NewsRoomDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__